import { NewToggleConditionSelector } from '../components/inventory/new-toggle-condition-selector.vue';
Vue.component('new-toggle-condition-selector', NewToggleConditionSelector);